<template lang="pug">
  div.inputselect
    //- div {{mainSelect}}
    v-select.noBG.relative.inputSelect(
      :clearable="false"
      v-model="mainSelect" 
      :class="{'validError': validClass}"
      :options='localArr' 
      @option:selecting="beforeSelect()" 
      @search:blur="onBlur"
      @input="onClick()" 
      multiple  
      :disabled= "isDisable"
      :selectable="option => !option.disabled"
      :close-on-select="false" 
      :reduce="localArr =>  localArr" 
      :label="localArr.id ?  'id':'name'"
      :searchable="isSearch")
      template(#search="{events, attributes}")
        input(class="vs__search" v-on="events" v-bind="attributes" )
        .absolute.mt-8.text-14.ml-5.align-middle.z-10.text-grey-4c(:class="{'text-grey-inputDisableText' : isDisable}") {{placeholder}}
      template(#list-header)
          .px-12.flex.justify-between.items-center.group.py-8.cursor-pointer(@mousedown="allCheck()" v-if="hasAllOption")
            div(class="group-hover:text-main-0") {{$t('__c6N3.__all')}}
            button.w-24.h-24.rounded-2.border.border-grey-d9(
              :class="{'check': allChecked}" 
              class="hover:border-main-0"
              )
      template( slot="option" slot-scope="option" )
        
        .flex.justify-between.group(@mousedown="onmousedown(option.id ? option.id: option.label)" )
          span {{option.name ? option.name : option.label}}{{option.label}}
          button.w-24.h-24.rounded-2.border.border-grey-d9(
            :class="{'check': checkStyle(option) , 'border-grey-9E' : !option.disabled, 'cursor-default': option.disabled,  'group-hover:border-main-0' : !option.disabled}" 
            )
      template( v-slot:no-options="{ search, searching }" v-if="isSearch") 
        em(v-if="searching") Sorry, no {{search}}'s matching options.
        em(v-else) Sorry, no options.
    .error.flex.items-center(v-show="error")
      small.text-error.pt-3 {{error}}
    
</template>

<script>
import Vue from "vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
// import { createPopper } from '@popperjs/core'



Vue.component("v-select", vSelect);
export default {
  name: 'InputSelect',
  props: {
    isSearch:{
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false
    },
    optionArr:{
      type: Array,
      require: false,
    },
    subCategory:{
      type: Array,
      require: false,
    },
    defaultSelectedValue: {
      type: [String, Array],
      required: false,
      default: '',
    },
    placeholder:{
      type: String,
      required: false,
    },
    isDisable: {
      type: Boolean,
      required: false,
      default: false,
    },
    error: String, //驗證文字
    required:{ //blur時紅框
      type: Boolean,
      default: false,
    },
    hasAllOption:{ //有All選項
      type: Boolean,
      default: false,
    },
  },
  components:{
    vSelect,
  },
  data() {
    return {
      allChecked: false,
      localArr : [],
      mainSelect: this.defaultSelectedValue,
      validClass: false,
      obj:[
        {id: 'ax',
          name: 'aaaaa',
        },
        {id: 'bx',
          name: 'bbbbb',
        },
        {id: 'cx', 
          name: 'ccccc',
        },
        {id: 'dx', 
          name: 'ddddd',
        }
      ],
      temp:'',
    };
  },
  created(){
  },
  mounted(){
    
    this.validClass = this.error ? true : false;
  },
  methods:{
    allCheck(){
      this.allChecked = !this.allChecked;
      if(!this.allChecked){
        this.mainSelect = []
      }
    },
    onmousedown(id) {
      this.temp = id;
    },
    beforeSelect(){ //反轉checkbox已選擇選項

      for (let i = 0; i < this.mainSelect.length; i++) {
        if(this.mainSelect[i].id.indexOf(this.temp) > -1){
          this.mainSelect.splice(i,1)
        }
      }

      // this.temp ='';
      this.onClick()
    },
    onClick() {
      // console.log(this.mainSelect,'666')
      this.$emit("onClick", this.mainSelect);
      
    },
    close(){
    },
    onBlur(){
      if(!this.mainSelect.length  && this.required ){
        this.validClass = true
      }else{
        this.validClass = false
      }
      this.$emit("onblur",{ val: !this.validClass, key: this.name});

      this.$emit("emptyResult", this.noSearchResult);
    },
    checkStyle(option){
      let flag  = false;
      if(this.mainSelect.length){
        this.mainSelect.forEach(e => {
          if(e.id == option.id){
            flag =  true
          }
        });
      }
      return flag
    }
  },
  watch:{
    optionArr:{
      handler: function (n) { //驗證有填選則開啟BTN
        if(n,length){
          if(this.hasAllOption){
            n[0]['first'] = true
          }
        }
        this.localArr = n;
      },
      deep:true,
      immediate : true,
    },
    error(n){
      this.validClass = n ? true : false;

    },
    defaultSelectedValue:{
      handler:function(n){ 
        this.mainSelect = n
      },
      deep:true,
    },
    mainSelect:{
      handler:function(n){ 
        let enable  = this.localArr.filter(e => !e.disabled );
        let checkArr = this.mainSelect.filter(e => !e.disabled );
        // console.log('enable : ',enable, 'checkArr : ',checkArr)
        this.allChecked = enable.length === checkArr.length ? true :false;
      },
      deep:true,
    },
    allChecked:{
      handler:function(n){ 
        if(n){
          let temp = this.localArr
          this.mainSelect = temp.filter(e => !e.disabled );
        }
        this.onClick()
      },
      deep:true,
    },

  },
  computed: {
    
  },
}
</script>

<style lang="scss" scoped>

.check{
  background-image: url('~@/assets/svgUnHash/check.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right;

}



</style>
